import LoadingView from 'components/LoadingView';
/**
 * Asynchronously loads the component for NotFoundPage
 */
import React, { lazy, Suspense } from 'react';
import retryPromise from 'utils/retryPromise';

const Component = lazy(() => retryPromise(() => import('./index')));

interface LoadableProps {
  [key: string]: any; // Allow any props to be passed through
}

const loadable = (props: LoadableProps) => (
  <Suspense fallback={<LoadingView />}>
    <Component {...props} />
  </Suspense>
);

export default loadable;
